export const SOURCE_STRINGS = {
  Nespechej: 'Nespěchej.cz',
  NasDum: 'Nášdům.eu',
  PlneZdravi: 'Plnézdraví.cz',
  NaseZahrada: 'Našezahrada.com',
  EPenize: 'Epeníze.eu',
  SvetCestovatele: 'Světcestovatele.cz',
  Aktualne: 'Aktuálně.cz',
  Vareni: 'Vaření.cz',
  Woman: 'Žena.cz',
  Nova: 'TN.cz',
  Utulne: 'Útulně',
  Video: 'Aktuálně.cz',
  Magazin: 'Aktuálně.cz',
  MagazinZahrada: 'Magazín zahrada',
  AktualneAuto: 'Aktuálně.cz',
  VitalWeb: 'Vitalweb.cz',
  Kinotip: 'Kinotip',
  Zdrave: 'Zdravě',
  FajntipPsychologie: 'Fajntip',
  Ekonom: 'Ekonom',
  Mimibazar: 'Mimibazar',
  EFotbal: 'Efotbal',
  GolfDigest: 'GolfDigest',
  Kutilove: 'Kutilove.cz',
  Marianne: 'Marianne.cz',
  Elle: 'Elle.cz',
  Chip: 'Chip.cz',
  SvetZeny: 'Světženy.cz',
  NaseKrasnaZahrada: 'NKZ.cz',
  Kinobox: 'Kinobox.cz',
  Tvguru: 'TVGuru.cz',
  Devetletnatvrdo: 'Datarun.cz',
  Soiree: 'Datarun.cz',
  Vysokenapeti: 'Datarun.cz',
  Ko: 'Datarun.cz',
  Zivotvgymu: 'Datarun.cz',
  Vsechnomacenu: 'Datarun.cz',
  Padouchnebohrdina: 'Datarun.cz',
  FajntipLifestyle: 'Fajntip',
  VipShow: 'VipShow.cz',
  TechSvet: 'TechSvet.cz',
  SportDenik: 'SportDenik.cz',
  Pravda24: 'Pravda24.cz',
  NeposlusneTlapky: 'NeposlusneTlapky.cz',
  FreeLite: 'FreeLite.cz',
  Netflixer: 'Netflixer.cz',
  GrapesMag: 'GrapesMag',
  ZivotCestovatele: 'Život Cestovatele',
  ZenaIn: 'Žena-IN',
  Extra: 'eXtra.cz',
  Lifee: 'Lifee.cz',
  Proboha: 'Proboha!'
}

export const SOURCE_IMAGES = {
  Nespechej: 'nespechej.png',
  NasDum: 'nasdum.png',
  PlneZdravi: 'plnezdravi.png',
  NaseZahrada: 'nasezahrada.png',
  EPenize: 'epenize.png',
  SvetCestovatele: 'svetcestovatele.png',
  Aktualne: 'aktualne.svg',
  Vareni: 'vareni.svg',
  Woman: 'zena.svg',
  Nova: 'tn.svg',
  Utulne: 'utulne.svg',
  Video: 'aktualne.svg',
  Magazin: 'aktualne.svg',
  MagazinZahrada: 'magazinzahrada.png',
  AktualneAuto: 'aktualne.svg',
  VitalWeb: 'vitalweb.svg',
  Kinotip: 'kinotip.png',
  Zdrave: 'zdrave.svg',
  FajntipPsychologie: 'fajntip.png',
  Ekonom: 'ekonom.svg',
  Mimibazar: 'mimibazar.png',
  EFotbal: 'efotbal.png',
  GolfDigest: 'golfdigest.png',
  Kutilove: 'kutilove.png',
  NaseKrasnaZahrada: 'nasekrasnazahrada.png',
  SvetZeny: 'svetzeny.png',
  Marianne: 'marianne.png',
  Elle: 'elle.png',
  Kinobox: 'kinobox.png',
  Tvguru: 'tvguru.png',
  Chip: 'chip.png',
  Devetletnatvrdo: 'datarun.png',
  Soiree: 'datarun.png',
  Vysokenapeti: 'datarun.png',
  Ko: 'datarun.png',
  Zivotvgymu: 'datarun.png',
  Vsechnomacenu: 'datarun.png',
  Padouchnebohrdina: 'datarun.png',
  FajntipLifestyle: 'fajntip.png',
  VipShow: 'vipshow.png',
  TechSvet: 'techsvet.webp',
  SportDenik: 'sportdenik.png',
  Pravda24: 'pravda24.png',
  NeposlusneTlapky: 'neposlusnetlapky.png',
  FreeLite: 'freelite.png',
  Netflixer: 'netflixer.jpg',
  GrapesMag: 'grapesmag.png',
  ZivotCestovatele: 'zivot-cestovatele.png',
  ZenaIn: 'zena-in.png',
  Extra: 'extra.png',
  Lifee: 'lifee.png',
  Proboha: 'proboha.png'
}

export const ALREADY_USED_ARTICLES_WIDGETS = [
  'dynamiclead',
  'news',
  'video',
  'woman',
  'sport',
  'magazine',
  'finance',
  'newsfeed',
  'celebritiesInverted'
]
